// Core React libraries import
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Core ANTD libraries import
import { Row, Col } from 'antd';

// EZ web-app utils import
import { loginInterface, portToString } from '../utils/ez_api//authUtil';
import { isDemoENV } from 'utils/envUtil';
// EZ web-app components import
import { IResolveParams } from '../components/social';
import { LogoImg } from '../components/social/LogoImg';
import { DemoBanner } from 'components/general/demoBanner';
// EZ web-app pages import
import { LoginUser } from './subpages/LoginUser';
// EZ web-app styles import
import '../styles/login.scss';

export interface LoginProps {
    handleResolve: any;
    handleReject: any;
    userLoggedIn: any;
    showNotification?: any;
}

export const Login = React.memo(function Login(props: any) {
    // const [isLoading, setIsLoading] = React.useState(false);
    // const [isRegisterOpen, setRegisterOpen] = React.useState(false);
    const history = useHistory();
    const location = useLocation();
    // const [notificationSuccess, setNotificationSuccess] = useState<string | null>(null);

    // Get redirect parameter from URL
    const queryParams = new URLSearchParams(location.search);
    const redirectPath = queryParams.get('redirect');

    useEffect(() => {
        if (localStorage.getItem('jwt')) {
            // If already logged in and there's a redirect, go there
            if (redirectPath) {
                history.push(`/${redirectPath}`);
            } else {
                history.push('/home');
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleLoginResolve = (res: IResolveParams) => {
        // setIsLoading(true);
        localStorage.setItem('loginType', portToString(res.provider));
        localStorage.setItem('loginToken', res?.data?.access_token);
        loginInterface(res.provider, res?.data?.access_token).then(res => {
            localStorage.setItem('jwt', res.data.jwt);
            // Navigate to redirect path or default to home
            if (redirectPath) {
                history.push(`/${redirectPath}`);
            } else {
                history.push('/home');
            }
        });
    };

    const handleReject = (err: any) => {
        console.log('🚀 ~ file: Login.tsx:56 ~ handleReject ~ err', err);
    };

    // const handleSignUp = () => {
    //     history.push('/verify-user');
    // };

    const handleLogin = () => {
        // Navigate to redirect path or default to home
        if (redirectPath) {
            history.push(`/${redirectPath}`);
        } else {
            history.push('/home');
        }
    };

    // if (isLoading) return <Spin />;

    return (
        <>
            <Helmet>
                <title>EZ Coordinator Login | Access Your Real Estate Dashboard</title>
                <meta
                    name="description"
                    content="Log in to your EZ Coordinator account to stay on top of your real estate deals with simple, secure transaction management."
                />
            </Helmet>
            <Row justify="center">
                <Col
                    xs={{ offset: 0, span: 16 }}
                    sm={{ offset: 0, span: 16 }}
                    md={{ offset: 0, span: 12 }}
                    lg={{ offset: 0, span: 12 }}
                    xl={{ offset: 0, span: 8 }}
                >
                    <div className="login-wrapper">
                        <div className="login-page">
                            <LogoImg />
                            <div className="login-register-wrapper">
                                <LoginUser
                                    handleResolve={handleLoginResolve}
                                    handleReject={handleReject}
                                    userLoggedIn={handleLogin}
                                />
                                <div className="new-registration mt-4 pt-4">
                                    {!isDemoENV() && (
                                        <span>
                                            Not registered yet?{' '}
                                            <Link to="/register">
                                                <span className="">Register</span>
                                            </Link>
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col>{isDemoENV() && <DemoBanner />}</Col>
            </Row>
        </>
    );
});
